import "./Cards.css";
export default function Certificate() {
  //⭐ Javascript basics from Udemy
  return (
    <div className="cert">
      <h1>CERTIFICATES</h1>
      <div className="table-container">
        <div className="table">
          <table>
            <tr>
              <td>⭐</td>
              <td>Python for Everybody from Coursera</td>
            </tr>
            <tr>
              <td>⭐</td>
              <td>Full Stack web development from Udemy</td>
            </tr>
            <tr>
              <td>⭐</td>
              <td>Python Programming from Aptron Solutions</td>
            </tr>
            <tr>
              <td>⭐</td>
              <td>Javascript basics from Udemy</td>
            </tr>
          </table>
        </div>
      </div>
    </div>
  );
}
